<template>
  <v-app>

    <router-view/>

  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',

  mixins: [],

  components: {

  },

  data: () => ({
    //
  }),

  computed:
  {
    
  },

  mounted()
  {
    window.addEventListener("message", (event) => {
      /*
      if (event.origin !== "http://example.org:8080")
        return;
      */
      
      const data = event.data

      if( data.route )
        this.route(data.route)

    }, false);
  },

  methods:
  {
    ...mapActions({
      route: 'menu/route'
    })
  },

  watch:
  {
    
  }
};
</script>
